import {
    Component,
    ojs,
    app,
    context,
    each,
    payload,
    state,
    v,
    component,
} from "modular-openscriptjs";
import {
    cleanDispose,
    eParse,
    oneOf,
    empty,
    inform,
    isMobile,
} from "../../helpers";
import { dom, tool } from "../../fotastart";
import { Notice, STRINGS } from "../../declarations";
import AddressPickerForm from "./AddressPickerForm";
import CheckYesno from "../Blocks/CheckYesno";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");

ojs(AddressPickerForm, CheckYesno);

export default class DeliveryAddressForm extends Component {
    holder = null;
    deliversToSomeoneElse = state(false);
    chosenAddress = state({});

    renderForm(...args) {
        return h.div(
            { class: "container p-2" },
            h.h4({ class: "text-center fw-bold mb-4" }, "Add Delivery Address"),
            h.form(
                {
                    class: "delivery-form d-flex flex-column gap-3",
                },

                // 1. Map pinpoint section (Enforced)
                h.div(
                    { class: "mb-3" },
                    h.label(
                        {
                            class: "form-label small fw-bold text-secondary",
                        },
                        "Map Location",
                    ),

                    h.input({
                        type: "hidden",
                        id: "primary-address",
                    }),
                    h.input({ type: "hidden", id: "daf-latitude" }),
                    h.input({ type: "hidden", id: "daf-longitude" }),

                    v(this.chosenAddress, (addr) => {
                        if (empty(addr.value)) {
                            return h.div(
                                {
                                    class: "card border-primary border-2 bg-light shadow-sm mb-3 overflow-hidden",
                                    onclick: this.method("openMap"),
                                    role: "button",
                                    style: "border-style: dashed !important; cursor: pointer;",
                                },
                                h.div(
                                    { class: "card-body text-center py-4" },
                                    h.i({
                                        class: "fas fa-map-marked-alt fa-2x text-primary mb-2",
                                    }),
                                    h.h6(
                                        { class: "fw-bold text-dark mb-1" },
                                        "Set Precise Location",
                                    ),
                                    h.span(
                                        { class: "text-muted small" },
                                        "Tap to open map and pin your location",
                                    ),
                                ),
                            );
                        }

                        return h.div(
                            {
                                class: "card border-0 shadow-sm bg-white p-3 mb-3 d-flex flex-row align-items-center justify-content-between",
                                onclick: this.method("openMap"),
                                role: "button",
                                style: "cursor: pointer;",
                            },
                            h.div(
                                {
                                    class: "d-flex align-items-center gap-3 overflow-hidden",
                                },
                                h.i({
                                    class: "fas fa-map-pin text-primary fs-4",
                                }),
                                h.div(
                                    { class: "overflow-hidden" },
                                    h.span(
                                        {
                                            class: "text-muted small d-block mb-0.5",
                                        },
                                        "Delivery Location",
                                    ),
                                    h.div(
                                        {
                                            class: "fw-bold text-dark text-truncate small",
                                        },
                                        addr.value?.address,
                                    ),
                                ),
                            ),
                            h.i({
                                class: "fas fa-chevron-right text-muted ms-2",
                            }),
                        );
                    }),
                ),

                // 2. Specific landmark / Apartment notes
                h.div(
                    { class: "mb-3" },
                    h.label(
                        {
                            class: "form-label small fw-bold text-secondary",
                            for: "additional-information",
                        },
                        "House / Apartment / Landmark (optional)",
                    ),
                    h.textarea({
                        class: "form-control form-control-lg rounded-3 bg-light border-0 p-3",
                        id: "additional-information",
                        rows: 3,
                        style: "resize: none;",
                        placeholder:
                            "e.g. Green Apartment, 3rd Floor, House 4B...",
                    }),
                ),

                // 3. Conditional Recipient Selection
                h.div(
                    h.CheckYesno(
                        {
                            label: {
                                value: "Delivering to someone else?",
                                class: "fw-bold",
                            },
                            id: "daf-recipient-toggle",
                            role: "switch",
                            onchange: this.method("toggleRecipientContainer"),
                        },

                        {
                            class: "check-yesno-end d-flex justify-content-between align-items-center w-100",
                        },
                    ),
                ),

                // 4. Recipient Inputs wrapped in v state wrapper
                v(this.deliversToSomeoneElse, (delivers) => {
                    if (!delivers.value) return h.empty();

                    return h.div(
                        {
                            class: "d-flex flex-column gap-3",
                            id: "daf-recipient-fields-container",
                        },
                        h.div(
                            { class: "mb-1" },
                            h.label(
                                {
                                    class: "form-label small fw-bold text-secondary",
                                    for: "address-recipient-name",
                                },
                                "Recipient Full Name",
                            ),
                            h.input({
                                class: "form-control form-control-lg rounded-3 bg-light border-0 px-3",
                                id: "address-recipient-name",
                                placeholder: "e.g. John Doe",
                            }),
                        ),
                        h.div(
                            { class: "mb-1" },
                            h.label(
                                {
                                    class: "form-label small fw-bold text-secondary",
                                    for: "address-phone-input",
                                },
                                "Recipient Phone Number",
                            ),
                            h.div(
                                { class: "input-group input-group-lg" },
                                h.select(
                                    {
                                        class: "form-select bg-light border-0 text-muted",
                                        style: "max-width: 100px;",
                                        id: "profile-country-code",
                                    },
                                    h.option({ value: "+254" }, "+254"),
                                ),
                                h.input({
                                    class: "form-control bg-light border-0",
                                    id: "address-phone-input",
                                    placeholder: "712 345 678",
                                }),
                            ),
                        ),
                    );
                }),

                // 5. Submit Form Triggers
                h.div(
                    {
                        class: "d-flex justify-content-between gap-3 mt-4 pt-2",
                    },
                    h.button(
                        {
                            class: "btn btn-light rounded-pill px-4 py-3 text-muted fw-medium",
                            onclick: this.method("closeForm"),
                            type: "button",
                        },
                        "Cancel",
                    ),
                    h.button(
                        {
                            class: "btn btn-dark rounded-pill px-4 fw-bold py-3",
                            id: "daf-save-address-btn",
                            type: "button",
                            onclick: this.method("saveAddress", ["${this}"]),
                        },
                        "Save Address",
                    ),
                ),
            ),
            ...args,
        );
    }

    $$deliveryAddress = {
        stored: (ed, event) => {
            this.closeForm();
        },

        needs: {
            addressForm: (ed, event) => this.showForm(ed),
        },

        has: {
            storageError: (ed, event) => {
                const btn = dom.id("daf-save-address-btn");
                dom.enable(btn);
                dom.put("Save Address", btn);
            },
        },
    };

    $$location = {
        is: {
            available: (ed, event) => {
                this.setAccurateAddress(ed);
            },
        },
    };

    setAccurateAddress(ed) {
        let { meta, message } = eParse(ed);

        if (meta.from !== "DAF") return;

        let address = message.address;
        let latitude = message.latitude;
        let longitude = message.longitude;

        dom.id("primary-address").value = address;
        this.chosenAddress.value = { address, latitude, longitude };

        dom.id("daf-latitude").value = latitude;
        dom.id("daf-longitude").value = longitude;
    }

    showForm(ed) {
        let data = eParse(ed);

        if (this.holder) {
            cleanDispose(this.holder);
        }

        if (isMobile()) {
            this.holder = tool.offcanvas(
                h.DeliveryAddressCanvas(this.renderForm(data?.message?.item), {
                    class: "p-0 rounded-top-5",
                }),
            );
        } else {
            this.holder = tool.plainModal(
                h.DeliveryAddressModal(this.renderForm(data?.message?.item)),
            );
        }

        this.holder.show();
        this.openMap();
    }

    saveAddress(btn) {
        dom.disable(btn);
        h.Spinner({ parent: btn, resetParent: true });

        const isDeliveringToSomeoneElse =
            dom.id("daf-recipient-toggle")?.checked || false;
        let recipientName = null;
        let phone = null;

        if (isDeliveringToSomeoneElse) {
            recipientName = dom.id("address-recipient-name")?.value || null;
            phone = dom.id("address-phone-input")?.value || null;
        }

        let p = {
            recipient_name: recipientName,
            phone: phone,
            address: dom.id("primary-address")?.value || null,
            additional_information:
                dom.id("additional-information")?.value || null,
        };

        if (!empty(dom.id("daf-latitude").value)) {
            p.latitude = dom.id("daf-latitude").value;
        }

        if (!empty(dom.id("daf-longitude").value)) {
            p.longitude = dom.id("daf-longitude").value;
        }

        broker.send($e.deliveryAddress.needs.storage, payload(p));
    }

    closeForm() {
        this.holder.hide();
    }

    openMap() {
        let location = {};

        if (!empty(this.chosenAddress.value)) {
            location.latitude = this.chosenAddress.value?.latitude;
            location.longitude = this.chosenAddress.value?.longitude;
        }

        broker.send($e.location.is.needed, payload(location, { from: "DAF" }));
    }

    toggleRecipientContainer() {
        this.deliversToSomeoneElse.value = !this.deliversToSomeoneElse.value;
    }
}

export function DeliveryAddressCanvas(...args) {
    return h.$(h.div({ class: "offcanvas-body p-4" }, ...args));
}

export function DeliveryAddressModal(...args) {
    return h.$(
        h.div(
            {
                class: "modal-content border-0 rounded-4 shadow-lg", // More rounded modal
            },
            h.div(
                {
                    class: "modal-body p-4", // Added padding
                },
                ...args,
            ),
        ),
    );
}

ojs(DeliveryAddressForm, DeliveryAddressCanvas, DeliveryAddressModal);
